import { useTheme } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Drawer } from '@modules/_shared/components/drawer/Drawer';
import { OrganisationSettings } from '@modules/organisations/OrganisationSettings';
import { useLocale } from '@shared/hooks/locale';

/** Query param that toggles the stacked edit drawer over the organisation tabs. */
export const ORGANISATION_EDIT_PARAM = 'edit';

/**
 * Stacked drawer that hosts the shared organisation update form. Opened on top
 * of the organisation tabs (e.g. from the Analytics card) via the `?edit=1`
 * search param so it overlays without leaving the current tab.
 */
export const OrganisationEditDrawer = ({
  organisationId,
}: {
  organisationId: string;
}) => {
  const { t } = useLocale();
  const { breakpoints } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleClose = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete(ORGANISATION_EDIT_PARAM);
    navigate({ search: nextParams.toString() }, { replace: true });
  };

  return (
    <Drawer
      onClose={handleClose}
      title={t('Edit organisation')}
      maxWidth={breakpoints.values.md}
    >
      <OrganisationSettings
        organisationId={organisationId}
        onSaved={handleClose}
      />
    </Drawer>
  );
};
